import { isValidHtml, sanitizeHtml, stripHtml } from 'utils/richText'

const QuestionTitle = ({ children }: { children: string }) => {
  if (isValidHtml(children)) {
    return (
      <h1
        dangerouslySetInnerHTML={{ __html: sanitizeHtml(children) }}
        className="rich-text-content text-2xl font-light text-gray-1"
      />
    )
  }

  return (
    <h1 className="whitespace-pre-line text-2xl font-light text-gray-1">
      {stripHtml(children)}
    </h1>
  )
}

export default QuestionTitle
